import LoginForm from '../forms/LoginForm';

const ReturningCustomer = (props) => {
  const { redirectLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Returning Customer</h4>
      <LoginForm
        redirectLink={redirectLink}
        forgotPasswordLink="/profile/forgot-password"
        magicLink="/profile/magic-link"
      />
    </div>
  );
};

export default ReturningCustomer;
